import { createAction, props } from '@ngrx/store';

export const LOADS_SOURCING = {
	// No-op action for effects that need to return an action but don't need to trigger state changes
	NOOP: createAction('[Loads Sourcing] No-op'),

	LOADS_LIST: {
		PAGE: createAction('[Loads Sourcing] Set loads sourcing page', props<any>()),
		PAGE_SIZE: createAction('[Loads Sourcing] Set loads sourcing page size', props<any>()),
		GET: createAction('[Loads Sourcing] Get loads sourcing list', props<any>()),
		GET_AVAILABLE: createAction('[Loads Sourcing] Get available loads', props<any>()),
		GET_BOOKED: createAction('[Loads Sourcing] Get booked loads', props<any>()),
		GET_BATCH: createAction('[Loads Sourcing] Get batch loads list', props<any>()),
		SUCCESS: createAction('[Loads Sourcing] Get loads sourcing list success', props<any>()),
		FAILURE: createAction(
			'[Loads Sourcing] Get loads sourcing list failure',
			props<{ payload: { message: string } }>()
		),
		SET_FILTER: createAction(
			'[Loads Sourcing] Set loads sourcing filters',
			props<{ equipment: string; originState: string; batchId: string }>()
		),
		SET_LOAD_TYPE: createAction('[Loads Sourcing] Set load type', props<{ loadType: string }>()),
		SORT: createAction('[Loads Sourcing] Sort loads sourcing list', props<{ sortList: any[] }>()),
		FILTER_LIST: createAction(
			'[Loads Sourcing] Filter loads sourcing list',
			props<{ filtersList: any[] }>()
		),
		UPDATE: createAction(
			'[Loads Sourcing] Update a load in the loads sourcing list',
			props<{ updatedLoad: any }>()
		),
		// WebSocket: Fetch and add single load by bidId
		FETCH_LOAD_BY_BID_ID: createAction(
			'[Loads Sourcing] Fetch Load By Bid Id',
			props<{ bidId: string }>()
		),
		// Add single load to list (from WebSocket INVITED notification)
		ADD_LOAD_TO_LIST: createAction('[Loads Sourcing] Add Load To List', props<{ load: any }>()),
		// Client-side filter/sort applied (batch flow only)
		CLIENT_FILTER_SUCCESS: createAction('[Loads Sourcing] Client-side filter success', props<{ data: any[] }>()),
	},
	CARRIER: {
		CARRIER_ID_SUCCESS: createAction('[Loads Sourcing] set carrier id', props<any>()),
		GET: createAction('[Loads Sourcing] Get carrier info', props<any>()),
		SUCCESS: createAction('[Loads Sourcing] Get carrier info success', props<any>()),
		FAILURE: createAction(
			'[Loads Sourcing] Get carrier info failure',
			props<{ payload: { message: string } }>()
		),
	},
	ACCOUNT: {
		ID_SUCCESS: createAction('[Loads Sourcing] set account id', props<any>()),
		LOGO_SUCCESS: createAction('[Loads Sourcing] set account logo', props<any>()),
		BUSINESS_NAME: createAction('[Loads Sourcing] set account business name', props<any>()),
	},
	OFFER: {
		ALL_BIDS_SUBMITTED: createAction('[Loads Sourcing] finished submitting all bids', props<any>()),
		OPEN_DIALOG: createAction('[Loads Sourcing] open make offers dialog', props<any>()),
		DIALOG_SUCCESS: createAction('[Loads Sourcing] successfully made offers', props<any>()),
		DIALOG_LOAD_SUCCESS: createAction(
			'[Loads Sourcing] successfully made offer for load',
			props<any>()
		),
		DIALOG_LOAD_FAILURE: createAction(
			'[Loads Sourcing] unsuccessfully made offer for load',
			props<any>()
		),
		DIALOG_RATE_CHANGE: createAction('[Loads Sourcing] dialog rate changed', props<any>()),
		CLOSE_DIALOG: createAction('[Loads Sourcing] close make offers dialog', props<any>()),
		FAILED: createAction('[Loads Sourcing] make offers failed', props<any>()),

		BID_SUBMIT_SUCCESS: createAction(
			'[Loads Sourcing] successfully submitted bid offer',
			props<any>()
		),
	},
	INSTRUCTIONS: {
		DIALOG: createAction('[Loads Sourcing] get settings for instructions dialog', props<any>()),
		DIALOG_OPEN: createAction('[Loads Sourcing] open instructions dialog', props<any>()),
		DIALOG_CLOSE: createAction('[Loads Sourcing] close instructions dialog', props<any>()),
	},
	RESET_STATE: createAction('[Loads Sourcing] Reset page state', props<any>()),
	SET: {
		COMPANY_LIST: createAction(
			'[Loads Sourcing] set companies list',
			props<{ accountsList: any[] }>()
		),
		OPEN_LOADS: createAction('[Loads Sourcing] set open loads', props<any>()),
		COUNT_OF_BIDS_BEING_ADDED: createAction(
			'[Loads Sourcing] set count of bids that are being added asynchronously',
			props<{ countOfBidsBeingAdded: number }>()
		),
	},

	DECLINE_OFFER: {
		DIALOG_OPEN: createAction(
			'[Loads Sourcing] open decline offer confirmation dialog',
			props<any>()
		),
		DIALOG_CLOSE: createAction(
			'[Loads Sourcing] close decline offer confirmation dialog',
			props<any>()
		),
		DECLINE: createAction('[Loads Sourcing] decline offer', props<any>()),
		FAILURE: createAction('[Loads Sourcing] failed to decline offer', props<any>()),
		SUCCESS: createAction('[Loads Sourcing] successfully declined offer', props<any>()),
	},

	UPDATE_LOAD_OWNER: {
		OPEN_DIALOG: createAction('[Loads Sourcing] open update load owner dialog', props<any>()),
		CLOSE_DIALOG: createAction('[Loads Sourcing] close update load owner dialog', props<any>()),
		UPDATE: createAction('[Loads Sourcing] update load owner', props<any>()),
		FAILURE: createAction('[Loads Sourcing] failed to update load owner', props<any>()),
		SUCCESS: createAction('[Loads Sourcing] successfully updated load owner', props<any>()),
	},

	WEBSOCKET_NOTIFICATIONS: {
		BROKER_COUNTERED: createAction('[Loads Sourcing] broker countered offer', props<any>()),
		SELECTED: createAction('[Loads Sourcing] broker selected carrier offer', props<any>()),
	},
};
